export const DELETE_SCHEDULE = 'schedules/DELETE';
export const RECEIVE_SCHEDULES = 'schedules/RECEIVE_SCHEDULES';
export const RECEIVE_SHIFTS = 'schedules/RECEIVE_SHIFTS';
export const SELECT_SHIFT = 'schedules/SELECT_SHIFT';
export const DESELECT_SHIFT = 'schedules/DESELECT_SHIFT';
export const UPLOAD_SCHEDULE = 'schedules/UPLOAD_SCHEDULE';
